import { withVersion } from 'api/utils/withVersion';
export var getAccountPath = function getAccountPath() {
    return withVersion.v1('/account');
};
export var getAccountPasswordPath = function getAccountPasswordPath() {
    return withVersion.v1('/account/password');
};
export var getAccountEmailChangePath = function getAccountEmailChangePath() {
    return withVersion.v1('/account/email-change');
};
export var getAccountResendEmailPath = function getAccountResendEmailPath() {
    return withVersion.v1('/account/resend-email');
};
export var getAccountChangeEmailInvitationPath = function getAccountChangeEmailInvitationPath(hash) {
    return withVersion.v1("/account/email-change/".concat(hash));
};
